module.exports = __webpack_public_path__ + "static/media/DUSK-BNB.64926100.svg";